/* Sprung auf den Personalizer-Rahmen, diXed 30.08.2026.
   Beim Aufruf von /pages/customizer beginnt der Blick am Rahmen statt an der
   Ueberschrift.

   Die Zielposition wird aus der gemessenen Kopfhoehe gerechnet, nicht aus
   einem festen Wert: Der klebende Kopf ist je nach Breite unterschiedlich
   hoch, gemessen 145 px auf dem Rechner und 171 px auf dem Handy. Ein fester
   Wert stimmt immer nur fuer eine Breite. */
(function () {
  var ZIEL = 'designer-container';
  var PFAD = '/pages/customizer';
  /* 0, damit der Seitentitel vollstaendig hinter dem Kopf liegt.
     Mit 8 px blieb seine Unterkante in der Luecke sichtbar, gemessen. */
  var LUFT = 0;

  if (location.pathname.indexOf(PFAD) === -1) return;
  if (location.hash) return;

  var ruhig = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Der Nutzer hat Vorrang, sobald er selbst scrollt. Die Sperre wird erst
     scharf gestellt, nachdem der Sprung stattgefunden hat, sonst bricht auf
     Beruehrungsgeraeten schon die erste Geste den Sprung ab, bevor er
     ueberhaupt lief. */
  var gesprungen = false;
  var selbstGescrollt = false;
  function merken() { if (gesprungen) selbstGescrollt = true; }
  window.addEventListener('wheel', merken, { passive: true });
  window.addEventListener('touchmove', merken, { passive: true });
  window.addEventListener('keydown', merken);

  function kopfHoehe() {
    var kopf = document.querySelector('.shopify-section-group-header-group')
      || document.querySelector('.section-header');
    if (!kopf) return 0;
    var cs = getComputedStyle(kopf);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
    return kopf.getBoundingClientRect().height;
  }

  var versuche = 0;
  function springen() {
    versuche++;
    if (selbstGescrollt) return;

    var el = document.getElementById(ZIEL);
    /* Der Rahmen kommt von spreadconnect und braucht einen Moment. Ohne Hoehe
       waere die Zielposition falsch. */
    if (!el || el.getBoundingClientRect().height < 100) {
      if (versuche < 40) { setTimeout(springen, 150); }
      return;
    }

    var ziel = el.getBoundingClientRect().top + window.scrollY - kopfHoehe() - LUFT;
    if (ziel < 0) ziel = 0;
    window.scrollTo({ top: ziel, behavior: ruhig ? 'instant' : 'smooth' });
    gesprungen = true;
  }

  if (document.readyState === 'complete') { setTimeout(springen, 200); }
  else { window.addEventListener('load', function () { setTimeout(springen, 200); }); }
})();
